// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./vue-toastr-2.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("669ba7fc", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/vue-toastr-2/dist/vue-toastr-2.min.css
// module id = 445
// module chunks = 27